import EventHandler from '@pixelunion/events';

export default class CollectionFilters {
  constructor(container) {
    if (!container) return;

    this.el = container;
    this.filterRange = this.el.querySelectorAll('[data-filter-range]');

    this.updateTimeout = null;
    this.allowedQueryParams = ['view', 'sort_by'];
    this.rangeNames = [];

    this.events = new EventHandler();

    /* For range input */
    this.filterRange.forEach(filter => {
      this.rangeNames.push(filter.name);
      this.events.register(filter, 'change', e => this._handleChange(e.currentTarget));
      this.events.register(filter, 'keyup', e => {
        if (e.key !== 'Tab') {
          this._handleChange(e.currentTarget);
        }
      });
    });
  }

  _handleChange(element) {
    // cancel any pending requests
    if (this.updateTimeout !== null) {
      clearTimeout(this.updateTimeout);
    }

    // Wait for user to finish entering input before reloading page
    this.updateTimeout = setTimeout(() => {
      this._getFilteredResults(element);
    }, 2000);
  }

  _getFilteredResults(element) {
    let searchParameters;
    const currentSearch = window.location.search.replace('?', '');
    const formData = new FormData(element.closest('form'));
    const newSearch = new URLSearchParams(formData).toString();

    // Filter through current search string to see if price range input already exists,
    // if it does, create new string without current price range parameters
    const splitCurrentSearch = currentSearch.split('&');
    let filteredCurrentSearch = splitCurrentSearch.filter(search => {
      if (search.includes(this.rangeNames[0]) || search.includes(this.rangeNames[1])) {
        return false;
      }

      return true;
    });

    filteredCurrentSearch = filteredCurrentSearch.join('&');

    // If current search parameters exist, append new search parameters
    // on to existing parameters
    if (filteredCurrentSearch.length > 0) {
      searchParameters = `${filteredCurrentSearch}&${newSearch}`;
    } else {
      searchParameters = `${newSearch}`;
    }

    let urlQueryString = '';

    if (searchParameters) {
      urlQueryString = `?${searchParameters}`;
    }

    window.location.search = urlQueryString;
  }

  unload() {
    if (this.events) {
      this.events.unregisterAll();
    }
  }
}
